import { render, staticRenderFns } from "./EmailConfigModal.vue?vue&type=template&id=73db7f21&scoped=true"
import script from "./EmailConfigModal.vue?vue&type=script&lang=js"
export * from "./EmailConfigModal.vue?vue&type=script&lang=js"
import style0 from "./EmailConfigModal.vue?vue&type=style&index=0&id=73db7f21&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73db7f21",
  null
  
)

export default component.exports